const titleCaseToCamelCaseArray = (text) => {
  const finalResult = text.split(',').map((word) => {
    if (word.split(' ').length === 1) return word?.toLowerCase();

    const camelCaseWord = word.split(' ').map((word, index) => {
      if (index === 0) return word;
      return word.slice(0, 1).toUpperCase() + word.slice(1).toLowerCase();
    });
    return camelCaseWord.join('');
  });
  return finalResult;
};

export default titleCaseToCamelCaseArray;
